import styled from '@emotion/styled';
import { Box } from '@mui/material';

import DelogueLogoName from 'img/delogue-logo-name.svg';
import { Image } from 'components/image/Image';

type FederatedAuthPageProps = {
  children: React.ReactNode;
};

export const CenterContainerFederated = ({ children }: FederatedAuthPageProps) => {
  return (
    <Container>
      <LogoContainer>
        <Image src={DelogueLogoName} alt="Delogue logo name" width="auto" />
      </LogoContainer>
      <Spacer>
        <ContentContainer
          sx={{
            maxWidth: { xs: '500px', md: '840px' },
          }}
        >
          {children}
        </ContentContainer>
      </Spacer>
    </Container>
  );
};

const Container = styled.main`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: ${p => p.theme.palette.bg.secondary};
  align-items: center;
`;

const LogoContainer = styled.div`
  margin-top: 36px;
  margin-bottom: 24px;
  flex-shrink: 0;
`;
const Spacer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const ContentContainer = styled(Box)`
  background-color: ${p => p.theme.palette.fg.white};
  min-height: 350px;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  border: ${p => `0.5px solid ${p.theme.palette.border.primarySubtle}`};
  box-shadow: 4px 8px 16px 0px rgba(34, 34, 34, 0.16);
  overflow: hidden;
`;
